<template>
  <div
    :class="['UILoader', `UILoader--theme-${theme}`]"
    data-testid="ui-loader"
  />
</template>

<script lang="ts" setup>
import { PropType } from 'vue'

defineProps({
  theme: {
    type: String as PropType<'dark' | 'light'>,
    default: 'dark',
  },
})
</script>

<style scoped lang="scss">
.UILoader {
  --size: 2rem;
  --color: #{$newcolor-secondary-main};

  border: 3px solid var(--color);
  border-right-color: transparent;
  border-radius: 50%;
  width: var(--size);
  height: var(--size);
  animation: 0.75s linear infinite spinner-border;

  @keyframes spinner-border {
    to {
      transform: rotate(360deg);
    }
  }

  &.UILoader--theme-dark {
    --color: #{$newcolor-secondary-main};
  }
  &.UILoader--theme-light {
    --color: #{$newcolor-secondary-light};
  }
}
</style>
